<template>
  <div class="app-footer-section">
    <b-container class="app-footer">
      <div class="logo-wrapper">
        <img :src="appLogo" class="app-logo" alt="" />
      </div>
      <div>Terms of Use | Privacy Policy</div>
      <div>© 2022 – 2025 Coinaholic. All Rights Reserved.</div>
    </b-container>
  </div>
</template>

<script>
import logo from "@/assets/img/logo.svg";

export default {
  name: "AppFooter",
  data() {
    return {
      appLogo: logo,
    };
  },
};
</script>

<style lang="scss" scoped>
.app-footer-section {
  width: 100%;
  height: 304px;
  background: #024089;
  position: relative;
  top: 38px;

  .app-footer {
    height: 100%;
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 20px;
    color: #fff;
    font-size: 20px;

    .logo-wrapper {
      .app-logo {
        height: 104px;
        width: 104px;
      }
    }
  }
}
@media (max-width: 475px) {
  .app-footer-section {
    height: 204px;
    top: 38px;

    .app-footer {
      gap: 15px;
      font-size: 16px;

      .logo-wrapper {
        .app-logo {
          height: 84px;
          width: 84px;
        }
      }
    }
  }
}
</style>
